var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.95836C0 3.26918 0.560837 2.70835 1.25001 2.70835H2.35377L5.00003 0.625V9.79173L2.35377 7.70838H1.25001C0.560837 7.70838 0 7.14754 0 6.45837V3.95836ZM9.87886 4.25221L8.92343 5.20763L9.87886 6.16306C10.0418 6.32597 10.0418 6.58931 9.87886 6.75223C9.79761 6.83348 9.69094 6.87431 9.58427 6.87431C9.4776 6.87431 9.37094 6.83348 9.28969 6.75223L8.33426 5.7968L7.37884 6.75223C7.29759 6.83348 7.19092 6.87431 7.08425 6.87431C6.97759 6.87431 6.87092 6.83348 6.78967 6.75223C6.62675 6.58931 6.62675 6.32597 6.78967 6.16306L7.74509 5.20763L6.78967 4.25221C6.62675 4.08929 6.62675 3.82596 6.78967 3.66304C6.95259 3.50012 7.21592 3.50012 7.37884 3.66304L8.33426 4.61846L9.28969 3.66304C9.4526 3.50012 9.71594 3.50012 9.87886 3.66304C10.0418 3.82596 10.0418 4.08929 9.87886 4.25221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMute);
export default __webpack_public_path__ + "static/media/volume-mute.c11afe61930fbafeb75aeb359f097d3e.svg";
export { ForwardRef as ReactComponent };